import { NavController } from '@ionic/angular';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { SideMenuOption } from './models/side-menu-option';
import { TokenService } from '../../servicios/token.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'custom-side-menu',
    templateUrl: './custom-side-menu.component.html',
    styleUrls: ['./custom-side-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomSideMenuComponent {
  optionHeight = 45;
  paddingLeft = 16;
  @Input() menuList: Array<SideMenuOption>;

  isLogged = false;
  nombreUsuario = '';
  password = '';

  constructor(private navCtrl: NavController, private tkS: TokenService) {
  }

  toggle(item) {
    item.expanded = !item.expanded;
  }

  vaciar() {
    this.nombreUsuario = '';
    this.password = '';
  }

  salir() {
    this.cerrarSesion().then(() => {
      this.vaciar();
      console.log("Cerrando sesión y redireccionando al login.");
    }).catch(error => {
      console.error("Error al cerrar sesión:", error);
    });
  }

  link_reglamento(){
    var reglamento = ''
    switch (environment.club){
      case 'alpha':
        reglamento = environment.reglamentoAlpha
        break;
      case 'sports':
        reglamento = environment.reglamentoSP
        break;
      case 'cimera':
        reglamento = environment.reglamentoCim
        break;
      case 'cenit':
        reglamento = environment.reglamentoCenit
        break;
      case 'cimeragym':
        reglamento = environment.reglamentoCimG
        break;
    };
    return reglamento
  }
  
  private async cerrarSesion() {
    try {
      const response = await this.tkS.logOut();
      console.log("Respuesta del servidor al cerrar sesión:", response);
      localStorage.setItem('ingresado', 'false');
      this.isLogged = false;
      this.vaciar();
      console.log("Usuario deslogueado de la app.");
      this.navCtrl.navigateRoot('/login');
      console.log("Redireccionando a la página de login.");
      console.log("Usuario deslogueado de las notificaciones.");
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  }
}
